import styles from './radioButton.module.css';

export default function RadioButton ({
  options,
  handleChange,
  groupLabel = null,
  className = null
}) {
  return (
    <div
      className={`au-form__item ${styles.radioContainer} ${className !== null && className}`}
    >
      {groupLabel && <label for='radio-button-group'>{groupLabel}</label>}
      <div id='radio-button-group' class='form-radios'>
        {options.map((option, index) => (
          <div class='au-form__item-type--radio' key={index}>
            <div class='au-control-input'>
              <input
                type='radio'
                id={`radio-button-${index}`}
                className='au-control-input__input'
                onClick={() => {
                  const tempOptions = options;
                  const unselectFlag = options[index].isChecked === true;
                  tempOptions.forEach((op) => {
                    op.isChecked = false;
                  });
                  if (unselectFlag === false) {
                    tempOptions[index].isChecked = true;
                  }
                  handleChange(tempOptions, !unselectFlag);
                }}
                checked={option.isChecked}
              />
              <label
                class={`au-control-input__text ${styles.customRadio}`}
                for={`radio-button-${index}`}
              >
                {option.label}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
